/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
// import { Print } from "@material-ui/icons";
import { Link, useNavigate } from "react-router-dom";
import Axios from "axios";
// import { useReactToPrint } from "react-to-print";
import HistoryBook from "../components/HistoryBook";
import { toast} from 'react-toastify'

function TablePageHistoryS({ classNo, seminarNo, isSubmit }) {
  const setClass = classNo;
  const setSeminar = seminarNo;
  const AccessRights = localStorage.getItem("AccessRights");
  const navigate = useNavigate()
  const CourseId = AccessRights.indexOf("-") !== -1 ? AccessRights.split("-")[1].trim() : AccessRights.substring(11, 14);
  const token = JSON.parse(localStorage.getItem('token'))
  var delayInMilliseconds = 3000
  // const CourseId = Id[0];
  const Access = localStorage.getItem("Access");
  // console.log(CourseId);
  const [selected, setSelected] = useState([]);
  const [noimage, setNoImage] = useState([]);
  // const [haveimage, setHaveImage] = useState("");
  // console.log(noimage);
  useEffect(() => {
    if (!isSubmit) return undefined;
    let cancelled = false;
    let logoutTimer;
    Axios.get(
      process.env.REACT_APP_API + `/result/course/${setClass}/seminar/${setSeminar}/${CourseId}?token=${token}`
    )
      .then((res) => {
        if (cancelled) return;
        setSelected(res.data.data1);
        setNoImage(res.data.data2)
        // setHaveImage(res.data.data3)
        // console.log("data: ", res.data.data2)
      })
      .catch((err) => {
        if (cancelled) return;
        if(err.response?.data?.message) {
          toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
          logoutTimer = setTimeout(function() {
            navigate('/')
            localStorage.clear();
          }, delayInMilliseconds);
        } else {
          console.log("err: ", err.response?.data)
        }
      })
    return () => {
      cancelled = true;
      if (logoutTimer) clearTimeout(logoutTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmit]);

  const columns = [
    {
      field: "id",
      pinnable: false,
      headerName: "ลำดับ",
      width: 80,
      align: "center",
      valueGetter: (params) => params.api.getRowIndex(params.row.PerId) + 1,
    },
    {
      field: "PerId",
      headerName: "เลขประจำตัว",
      width: 120,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "StudentId",
      headerName: "เลขประจำตัว นทน.",
      width: 150,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "Rank",
      headerName: "ยศ",
      width: 100,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "PersFname",
      headerName: "ชื่อ",
      width: 150,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "PersLname",
      headerName: "นามสกุล",
      width: 150,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "PersCorps",
      headerName: "เหล่า",
      width: 100,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "PersGrp",
      headerName: "จำพวก",
      width: 120,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "PersDutyNum",
      headerName: "ลชทอ.",
      width: 100,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "PersCurrPosition",
      headerName: "ตำแหน่ง",
      width: 200,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "PersAffiliation",
      headerName: "สังกัด",
      width: 120,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "print",
      headerName: "พิมพ์",
      width: 70,
      renderCell: (params) => {

        const ImgPic = noimage.map(
          (FetchEmailRegis) => FetchEmailRegis,
        )

        const FilterImgPic = ImgPic.filter(
          (EmailRegister) => EmailRegister === params.row.memimgpath,
        )
// console.log(typeof FilterImgPic.length)
     
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {/* <div ref={componentRef} >
                          <h1>Employee data</h1>
                    </div> */}
            <HistoryBook Data={params.row} Img={FilterImgPic.length === 0 ? "0" : FilterImgPic} />
            {/* <HistoryBook Data={params.row} /> */}
            {/* <HistoryBook Data={params.row}  Have={haveimage} /> */}
            {/* <Print  onClick={handlePrint} /> */}
          </div>
        );
      },
    },
    {
      field: "action",
      headerName:
        Access === "อาจารย์ประจำหมวดวิชา"
          ? ""
          : Access === "ปกครอง"
          ? ""
          : Access === "ผอ."
          ? ""
          : Access === "วัดผลส่วนกลาง"
          ? ""
          : "การจัดการ",
      width: 150,
      renderCell: (cellValues) => {
       
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {Access === "อาจารย์ประจำหมวดวิชา" ? (
              ""
            ) : Access === "ปกครอง" ? (
              ""
            ) : Access === "ผอ." ? (
              ""
            ) : Access === "วัดผลส่วนกลาง" ? (
              ""
            ) : (
            
              <Link
              to={`/PageEditHistoryS/${cellValues.row.AccessRightsId}`}
              state={{
                coursegrp: cellValues.row.CourseGrp,
                seminar: cellValues.row.Seminar,
              }}
            >
                <button
                  className="userListEdit"
                  onClick={(event) => {
                    handleClick(event, cellValues);
                  }}
                >
                  Edit
                </button>
              </Link>
            )}
          </div>
        );
      },
    },
  ];

  // เรียกข้อมูล

  const [studentList, setStudentList] = useState([]);

  const handleCellClick = (param, event) => {
    event.stopPropagation();
  };

  const handleRowClick = (param, event) => {
    event.stopPropagation();
  };

  const handleClick = (event, cellValues) => {
    // console.log(cellValues.row);
  };

  useEffect(() => {
    let cancelled = false;
    let logoutTimer;
    Axios.get(process.env.REACT_APP_API +`/PageHistoyrS?token=${token}`)
      .then((res) => {
        if (cancelled) return;
        setStudentList(res.data);
      })
      .catch((err) => {
        if (cancelled) return;
        if(err.response?.data?.message) {
          // toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
          logoutTimer = setTimeout(function() {
            navigate('/')
            localStorage.clear();
          }, delayInMilliseconds);
        } else {
          console.log("err: ", err.response?.data)
        }
      })
    return () => {
      cancelled = true;
      if (logoutTimer) clearTimeout(logoutTimer);
    };
  }, []);

  // console.log(studentList)
  
  const sortStudent = selected.slice().sort((a, b) => a.Seminar - b.Seminar); 
  
  // console.log("data sort: ", sortStudent);

  return (
    <div style={{ height: 700, width: "100%" }}>
      <DataGrid
        initialState={{
          pinnedColumns: { right: ['StudentId'] },
        }}
        getRowId={(row) => row.PerId}
        rows={sortStudent}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[5]}
        onCellClick={handleCellClick}
        onRowClick={handleRowClick}
      />
    </div>
  );
}

export default TablePageHistoryS;
